import axiosIns from '@/api/axios';
import querystring from 'query-string';

export const SUBMIT_BUDGET_PLAN = (body) => {
	return axiosIns.post('/plan', body);
};

export const GET_DATA_LIST = (params) => {
	return axiosIns.get(`/plan?${params}`);
};

export const GET_DETAIL = (id) => {
	return axiosIns.get(`/plan/${id}`);
};

export const DELETE_DATA = (id) => {
	return axiosIns.delete(`/plan/${id}`);
};

export const SAVE_VERSIONING = (args) => {
	return axiosIns.post(`/plan/${args.id}/new-version`, args.body);
};

export const SAVE_EXISTING = (args) => {
	return axiosIns.put(`/plan/${args.id}`, args.body);
};

export const IMPORT_FILE = (args) => {
	return axiosIns.post(`/plan/import`, args, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const GET_COMPARE = (body) => {
	return axiosIns.post(`plan/compare`, body);
};

export const GET_COMPARE_FILTER = (body) => {
	return axiosIns.post(`plan/compare`, body);
};

export const UPDATE_STATUS = (id) => {
	return axiosIns.patch(`/plan/${id}/status`);
};

export const LOCK_BUDGET_PLAN = (id) => {
	return axiosIns.patch(`/plan/${id}`);
};

export const APPROVE_BUDGET_PLAN = (id, reason) => {
	return axiosIns.patch(`/plan/${id}/approve?reason=${reason}`);
};

export const GET_LIST_DEPARTMENT = () => {
	return axiosIns.get('/fund-center/list-department');
};

export const GET_USER_BY_DEPARTMENT = (params) => {
	return axiosIns.get(`/plan/user-by-department?${querystring.stringify(params)}`);
};

export const UPLOAD_DOCUMENT = (body) => {
	return axiosIns.post(`/plan/upload-document`, body, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const SEND_NOTIFICATION = (body) => {
	return axiosIns.post(`/plan/send-notification`, body);
};

export const GET_ACTIVE_PLAN = () => {
	return axiosIns.get('/plan/active-plan');
};
